<template>
  <FullModal ref="FullModal" @close="close">
    <div class="details" v-loading="loading">
      <LableContent label="基本信息">
        <div class="base-info">
          <div
            v-for="(item, index) in form"
            :key="index"
            class="base-info-item"
          >
            <div class="label">{{ item.label }}</div>
            <div class="value">{{ item.value }}</div>
          </div>
        </div>
      </LableContent>

      <LableContent label="原始数据" hasCollapse showFullScreen>
        <TabBtn
          :tabs="tabs1"
          :active-tab="tabs1[0].vaule"
          :height="currentTab1.value !== 'projectOverview' ? '350px' : '530px'"
          @tab-click="handleTabChange"
        >
          <template slot="btn">
            <el-button type="primary" size="mini" @click="handleImportData">
              导入数据
            </el-button>
          </template>
          <template v-if="currentTab1.value !== 'projectOverview'">
            <SimpleTable
              ref="matchCostDetail"
              :loading="loading1"
              :table-code="currentTab1.tableCode"
              :columns="currentTab1.columns || [{}]"
              :data="tableData1"
            />
          </template>
          <template v-if="currentTab1.value === 'projectOverview'">
            <ProjectOverview :businessId="basicInfo.id" />
          </template>
        </TabBtn>
      </LableContent>
      <LableContent label="处理后的数据" hasCollapse showFullScreen>
        <TabBtn
          :tabs="tabs2"
          height="350px"
          :active-tab="tabs2[0].vaule"
          @tab-click="handleTabDealChange"
        >
          <template slot="btn">
            <el-button type="primary" size="mini" @click="handleDealData">
              数据处理
            </el-button>
          </template>
          <template>
            <LeftRightBox
              height="100%"
              :leftWidthDefault="450"
              style="margin-bottom: 10px"
            >
              <template
                slot="left"
                v-if="['gclqd', 'gszb'].includes(this.currentTab2?.value)"
              >
                <SimpleTable
                  ref="bottomLeftTable"
                  table-code="bottomLeftTable"
                  :menus="['查询', '批量修改', '批量删除']"
                  :columns="currentTab2.columnsLeft"
                  :data="tableData2Left"
                  :loading="loading2Left"
                  @row-select="onRowSelectBottomLeft"
                />
              </template>
              <template slot="right">
                <SimpleTable
                  :loading="loading2"
                  :table-code="currentTab2.tableCode"
                  :columns="currentTab2.columns || [{}]"
                  :data="tableData2"
                  :bottomFrozenRowCount="currentTab2.bottomFrozenRowCount"
                  @modify-data-change="handleModifyDataChange"
                />
              </template>
            </LeftRightBox>
          </template>
        </TabBtn>
      </LableContent>
    </div>
  </FullModal>
</template>

<script>
import FullModal from '@/components/FullModal/index.vue'
import LableContent from '@/components/LableContent/index.vue'
import SimpleTable from '@/components/SimpleTable/index.vue'
import TabBtn from '@/components/TabBtn/index.vue'
import LeftRightBox from '@/components/LeftRightBox/index.vue'
import ProjectOverview from './ProjectOverview.vue'
import { sortRecords, selectFile } from '@/utils/index'
import { fbfx, fyhz, csxm, rcj, zjzb, qd, qyde } from './column'

export default {
  name: 'HistoryDetails',
  components: {
    FullModal,
    LableContent,
    SimpleTable,
    TabBtn,
    ProjectOverview,
    LeftRightBox
  },
  provide() {
    return {
      detailsVm: this
    }
  },
  data() {
    return {
      // 页面数据
      basicInfo: {},
      form: [],
      loading: false,

      tabs1: [
        {
          label: '分布分项',
          value: 'fbfx',
          columns: fbfx,
          tableCode: 'historyDetails_fbfx',
          url: '/history-data-budget/bq-item/list'
        },
        {
          label: '措施项目',
          value: 'csxm',
          columns: csxm,
          tableCode: 'historyDetails_csxm',
          url: '/history-data-budget/measure-item/list'
        },
        {
          label: '人材机汇总',
          value: 'rcjhz',
          columns: rcj,
          tableCode: 'historyDetails_rcj',
          url: '/history-data-budget/resource/list'
        },
        {
          label: '费用汇总',
          value: 'fyhz',
          columns: fyhz,
          tableCode: 'historyDetails_fyhz',
          url: '/history-data-budget/summary/list'
        },
        {
          label: '工程概况',
          value: 'projectOverview',
          columns: fyhz,
          tableCode: 'historyDetails_fyhz',
          url: '/history-data-budget/summary/list'
        }
      ],
      currentTab1: {},
      tableData1: [],
      loading1: false,

      tabs2: [
        {
          label: '工程量清单',
          value: 'gclqd',
          tableCode: 'historyDetails_gclqd',
          columns: qd,
          columnsLeft: [{ field: 'name', title: '指标分类', tree: true }],
          bottomFrozenRowCount: 1,
          url: '/history-data-budget/bill/list'
        },
        {
          label: '人材机汇总',
          value: 'rcjhz',
          tableCode: 'historyDetails_rcjhz',
          columns: qyde,
          bottomFrozenRowCount: 1,
          url: '/history-data-budget/resource-summary/list',
          saveUrl: '/epiEnterpriseQuota/update/batch'
        },
        {
          label: '概算指标',
          value: 'gszb',
          tableCode: 'historyDetails_gszb',
          columnsLeft: [{ field: 'name', title: '指标分类', tree: true }],
          columns: zjzb,
          bottomFrozenRowCount: 1,
          url: '/history-data-budget/indicator/list'
        }
      ],
      currentTab2: {},
      tableData2: [],
      tableData2Left: [],
      loading2: false,
      loading2Left: false
    }
  },
  created() {
    const obj = this.tabs2.find(item => item.value === 'gszb')
    const element = obj.columns.find(item => item.field === 'costIndicator')
    const that = this
    element.aggregation[0].formatFun = function () {
      const total = that.tableData2.reduce(
        (acc, curr) => acc + curr.totalCost,
        0
      )
      return (total / that.basicInfo.constructionScale).toFixed(2)
    }
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    show(row) {
      this.getBaseInfo(row.id)
      this.$refs.FullModal.show({
        width: '100%',
        height: '100%',
        showConfirm: false,
        title: null,
        fullscreen: true,
        closeOnPressEscape: false
      })
    },

    async getBaseInfo(id) {
      const res = await this.$service.get('/history-data-budget/detail/' + id)
      this.basicInfo = sortRecords(res?.data || {})
      this.handleTabChange(this.tabs1[0])
      this.handleTabDealChange(this.tabs2[0])

      this.form = [
        { label: '历史工程名称', value: this.basicInfo.name },
        { label: '工程分类', value: this.basicInfo.engineeringClassifyName },
        { label: '所在地区', value: this.basicInfo.regionName },
        { label: '详细地址', value: this.basicInfo.address },
        { label: '建设规模', value: this.basicInfo.constructionScale },
        { label: '清单类型', value: this.basicInfo.billType },
        { label: '估算指标', value: this.basicInfo.totalCostIndicator },
        { label: '总造价', value: this.basicInfo.totalCost },
        { label: '开始时间', value: this.basicInfo.startDate },
        { label: '结束时间', value: this.basicInfo.endDate },
        { label: '工期(天)', value: this.basicInfo.duration },
        { label: '导入文件', value: this.basicInfo.fileName }
      ]
    },

    // 点击导入
    async handleImportData() {
      try {
        const file = await selectFile({
          accept: '.xlsx,.xls',
          multiple: false
        })
        if (file) {
          this.uploadFile(file)
        }
      } catch (error) {
        console.error('文件选择失败:', error)
      }
    },

    async uploadFile(file) {
      this.loading = true
      const formData = new FormData()
      formData.append('id', this.basicInfo.id)
      formData.append('file', file)
      const res = await this.$service.post(
        '/history-data-budget/import',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' }
        }
      )
      if (res.code === 200) {
        this.$message.success('导入成功')
        this.handleTabChange(this.currentTab1)
      }
      this.loading = false
    },

    // 点击处理数据
    async handleDealData() {
      if (!this.basicInfo.billType) {
        this.$message.warning('请先选择清单类型')
        return
      }
      this.loading = true
      const res = await this.$service.post(
        '/history-data-budget/process/' + this.basicInfo.id
      )
      if (res.code === 200) {
        this.$message.success('提取成功')
        this.handleTabDealChange()
      }
      this.loading = false
    },

    async handleTabChange(e) {
      if (e) this.currentTab1 = e
      if (this.currentTab1.value === 'projectOverview') {
        return
      }
      this.loading1 = true
      const res = await this.$service.get(this.currentTab1.url, {
        budgetId: this.basicInfo.id
      })
      this.loading1 = false
      this.tableData1 = sortRecords(res?.data || [])
    },

    async handleTabDealChange(e) {
      if (e) this.currentTab2 = e

      if (['gclqd', 'gszb'].includes(this.currentTab2?.value)) {
        this.getTableDataLeft(['gclqd'].includes(this.currentTab2?.value))
      } else {
        this.getTableDataRight()
      }
    },

    async getTableDataRight() {
      this.loading2 = true
      const res = await this.$service.get(this.currentTab2.url, {
        budgetId: this.basicInfo.id,
        indicatorId: ['gclqd', 'gszb'].includes(this.currentTab2?.value)
          ? this.currentSelectLeft?.id
          : undefined
      })

      this.loading2 = false
      this.tableData2 = sortRecords(res?.data || [])
    },

    async handleModifyDataChange(getModifyData, cleanModifyData) {
      const arr = getModifyData()
      if (!arr.length) return
      const res = await this.$service.post(this.currentTab2.saveUrl, arr)
      if (res?.code === 200) {
        this.$message.success('保存成功')
        cleanModifyData()
      }
    },

    async getTableDataLeft(includeThirdLevel) {
      this.loading2Left = true
      const res = await this.$service.get(
        '/history-data-budget/bill/measurement-indicator-category-tree/list',
        {
          budgetId: this.basicInfo.id,
          includeThirdLevel
        }
      )
      this.loading2Left = false
      let arr = res?.data
      if (this.currentTab2?.value === 'gszb') {
        const arr = res?.data?.[0]?.children || []
        arr.forEach(item => {
          item.children?.forEach(child => (child.children = []))
        })
      }
      this.tableData2Left = sortRecords(arr)
      this.$refs.bottomLeftTable.initialized()
    },

    async onRowSelectBottomLeft(rows) {
      const selectedRecord = rows[0]
      const obj = selectedRecord[0].originData
      this.currentSelectLeft = obj

      this.getTableDataRight()
    },

    close() {}
  }
}
</script>

<style scoped lang="less">
.details {
  padding-top: 10px;

  .base-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    row-gap: 16px;
    width: 100%;
    .base-info-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      width: 32%;
      color: #000;
      &:nth-child(3n -1) {
        margin: 0 2%;
      }
      .label {
        width: 142px;
        text-align: right;
        margin-right: 16px;
      }
      .value {
        height: 32px;
        flex: 1;
        background-color: #f5f5f5;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 6px;
        border: 1px solid #2a7ca7;
      }
    }
  }
}
</style>
